import {
    init as initAmplitude,
    track as trackAmplitude,
    identify as identifyAmplitude,
    Identify,
    getDeviceId as getDeviceIdFromAmplitude
} from '@amplitude/analytics-browser';
import { subscribe } from './event-logger';
import { AMPLITUDE_EVENT_TYPES, EVENT_TYPES } from './event-types';
import { getCookie, setCookie } from './cookie-helpers';

const amplitudeTracker = {
    DEVICE_ID_KEY: 'boundly_device_id',

    init(apiKey, serverUrl) {
        if (!apiKey) return;

        const deviceId = amplitudeTracker.getDeviceId();

        initAmplitude(apiKey, {
            includeUtm: true,
            defaultTracking: true,
            serverUrl,
            minIdLength: 1,
            ...(Boolean(deviceId) ? { deviceId } : {})
        });
    },

    getDeviceIdFromStorage() {
        return getCookie(amplitudeTracker.DEVICE_ID_KEY);
    },

    setDeviceIdToStorage(deviceId = '') {
        if (deviceId) {
            setCookie(amplitudeTracker.DEVICE_ID_KEY, deviceId, 365);
        }
    },

    getDeviceId() {
        let deviceId = amplitudeTracker.getDeviceIdFromStorage();

        if (!deviceId) {
            deviceId = getDeviceIdFromAmplitude() || window.crypto?.randomUUID?.();

            amplitudeTracker.setDeviceIdToStorage(deviceId);
        }

        return deviceId || '';
    },

    track(eventType, eventProperties = {}) {
        trackAmplitude(eventType, eventProperties);
    },

    setUserProperties(identifyData) {
        identifyAmplitude(identifyData);
    },

    onSubscribe() {
        return subscribe((eventType, eventProperties = {}) => {
            if (eventType === EVENT_TYPES.USER_PROPERTIES) {
                const identifyData = new Identify();

                Object.entries(eventProperties).map(property => identifyData.set(...property));

                return amplitudeTracker.setUserProperties(identifyData);
            }

            if (AMPLITUDE_EVENT_TYPES.hasOwnProperty(eventType)) {
                if (typeof AMPLITUDE_EVENT_TYPES[eventType] === 'function') {
                    return amplitudeTracker.track(AMPLITUDE_EVENT_TYPES[eventType](eventProperties));
                }

                amplitudeTracker.track(AMPLITUDE_EVENT_TYPES[eventType], eventProperties);
            }
        });
    }
};


export {
    amplitudeTracker
};
